import {Checkbox} from '../../components';

export default function CheckboxWrapper({data}) {
    return <Checkbox value={data} />;
}
